import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "../../lib/api";
import { Reveal } from "../../components/Motion";
import ProductCard from "../../components/ProductCard";
import ProductEnquiryDialog from "../../components/ProductEnquiryDialog";
import CheckoutDialog from "../../components/CheckoutDialog";

export default function FeaturedProducts() {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);
  const [buying, setBuying] = useState(null);

  useEffect(() => {
    api
      .get("/products")
      .then((r) => {
        const all = Array.isArray(r.data) ? r.data : [];
        const f = all.filter((p) => p.featured);
        setItems((f.length ? f : all).slice(0, 4));
      })
      .catch(() => setItems([]));
  }, []);

  return (
    <section data-testid="home-featured-products" className="bg-[var(--paper)] py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="eyebrow text-brand">Catalogue</p>
            <h2 className="mt-4 font-display text-5xl md:text-6xl font-extrabold uppercase leading-[0.92] text-navy">Featured products</h2>
          </div>
          <Link to="/products" data-testid="featured-view-all" className="group inline-flex items-center gap-2 font-semibold text-navy hover:text-brand">
            View full catalogue <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </Reveal>
        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {items.map((p, i) => (
            <ProductCard key={p.id} p={p} index={i} onEnquire={setActive} onBuy={setBuying} />
          ))}
        </div>
      </div>
      <ProductEnquiryDialog product={active} onClose={() => setActive(null)} />
      <CheckoutDialog product={buying} onClose={() => setBuying(null)} />
    </section>
  );
}
